module.exports = __webpack_public_path__ + "static/media/classroom.bc100457.png";